import React from 'react';
import { Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <>
      {/* Contact Section */}
      <section className="py-24 bg-gradient-to-br from-orange-400 via-orange-300 to-orange-200">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 text-white">
              {/* Left Side */}
              <div className="space-y-12">
                <div>
                  <div className="text-sm font-light tracking-widest mb-8 opacity-90">
                    GET IN TOUCH
                  </div>
                  <h2 className="text-5xl lg:text-6xl font-light leading-tight mb-8">
                    讓我們<br />
                    一起打造<br />
                    富而喜悅的新世代。
                  </h2>
                </div>
                <p className="text-lg font-light leading-relaxed opacity-90">
                  無論你是企業、教練、教育機構或合作夥伴，歡迎與我們展開對話。
                </p>
              </div>

              {/* Right Side */}
              <div className="space-y-12">
                {/* Email */}
                <div>
                  <div className="text-sm font-light tracking-widest mb-4 opacity-90">
                    EMAIL
                  </div>
                  <a 
                    href="mailto:mingyueculture@gmail.com"
                    className="text-2xl font-light hover:opacity-80 transition-opacity duration-300"
                  >
                    mingyueculture@gmail.com
                  </a>
                </div>

                {/* Locations */}
                <div className="grid grid-cols-2 gap-8">
                  <div>
                    <div className="text-sm font-light tracking-widest mb-4 opacity-90">
                      EU HQ
                    </div>
                    <div className="space-y-1 text-lg font-light">
                      <p>Sittard, Limburg</p>
                      <p>Netherlands</p>
                    </div>
                  </div>
                  <div>
                    <div className="text-sm font-light tracking-widest mb-4 opacity-90">
                      APAC BASE
                    </div>
                    <div className="space-y-1 text-lg font-light">
                      <p>台北市中正區南陽街3號4樓之一</p>
                      <p>Taiwan</p>
                    </div>
                  </div>
                </div>

                {/* Social Links */}
                <div>
                  <div className="text-sm font-light tracking-widest mb-4 opacity-90">
                    CONNECT
                  </div>
                  <div className="flex gap-4">
                    <a 
                      href="https://www.linkedin.com/in/katy-chen-24903955"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="px-6 py-3 border-2 border-white rounded-full hover:bg-white hover:text-orange-500 transition-all duration-300 font-light"
                    >
                      LinkedIn
                    </a>
                    <a 
                      href="https://www.youtube.com/@WealthJoy99"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="px-6 py-3 border-2 border-white rounded-full hover:bg-white hover:text-orange-500 transition-all duration-300 font-light"
                    >
                      YouTube
                    </a>
                    <a 
                      href="https://lin.ee/vIEtiT8"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="px-6 py-3 border-2 border-white rounded-full hover:bg-white hover:text-orange-500 transition-all duration-300 font-light"
                    >
                      Line
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Bottom Footer */}
      <footer className="bg-orange-500 py-8">
        <div className="container mx-auto px-6">
          <div className="text-center text-white text-sm font-light opacity-90">
            © 2026 明悅心創 Mingyue Culture. All Rights Reserved
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;